<template>
  <div id="app" :app-status="appStatus">
    <!-- <app-header  :scenes.sync="scenes" v-if="appStatus == 'loaded' && $route.path != '/'"></app-header> -->
    <app-header  :scenes.sync="scenes" v-if="appStatus == 'loaded'"></app-header>
    <!-- router-view nur dann rendern wenn appStatus == "loaded" oder so ... -->
    <router-view :scenes.sync="scenes" v-if="appStatus == 'loaded'"></router-view>
  </div>
</template>

<script>
// import "normalize.css";
import Header from './components/Header.vue';
// import Home from './components/Home.vue';
// import Panorama from './components/Panorama.vue';

/* grundlegende Einstellungen: */
/* Pfade zum Daten laden ... */
const settings = {
  getData: {
    basePath: "/scenes/",
    baseFile: "scenes.json",
    sceneFile: "config.json"
  }
};

/* load Pannellum Component ... */
// import VPannellum from 'vue-pannellum';
// import VuePannellum from './components/VuePannellum.vue'

export default {
  name: 'App',
  data() {
    return {
      // sceneIDs: [],
      scenes: {},
      // firstScene: null,
      // currentScene: null,
      appStatus: "initializing",
    }
  },
  components: {
    // Home,
    // Panorama,
    // VuePannellum,
    'app-header': Header
  },
  watch: {
    // $route(to) { // arguments possible: (to, from)
    $route() { // arguments possible: (to, from)
      // console.log(this.$route);
      // console.log(to);
      if (this.$route.name != 'panorama') {
        // this.$scrollTo("body", 1, {"offset": -50});
        // window.scrollTo(0,0);
        if (this.$route.hash) {
          // console.log(this.$route.hash);
          this.$scrollTo(this.$route.hash, 300, {"offset": -50});
        } else {
          this.$scrollTo("body", 1, {"offset": -50});
        }
      }
    },
  },
  created: function() {
    this.loadData();
  },
  methods: {
    loadData: function() {
      this.appStatus = "loading";
      // Schritt 1: hole Daten-Übersicht ...
      let baseFileURL = settings.getData.basePath + settings.getData.baseFile;
      this.$http.get(baseFileURL, {
        responseType: "json"
      }).then(response => {
        // success: get response data
        // console.log("loading baseFile: success", response.body);
        let pFolders = response.body;
        // Schritt 2: hole einzelne scene-Daten ...
        let pTemp = {};
        let pCounter = 0;
        for (let i in pFolders) {
          let pNr = parseInt(i) + 1;
          let pPath = settings.getData.basePath + pFolders[i];
          this.$http.get(pPath + "/" + settings.getData.sceneFile, {
            responseType: "json"
          }).then(response => {
            // success: get response data
            // console.log("loading scene "+pNr+" of "+pFolders.length+": success");
            // & prozessiere Daten:
            let pData = response.body;
            // & ergänze sceneId ...
            pData["sceneId"] = pFolders[i];
            if (typeof pData === 'object' && pData !== null) {
              if (pData.type == "multires" && pData.multiRes && pData.multiRes.path && pData.multiRes.fallbackPath) {
                // multiRes.Path // multiRes.fallbackPath
                pData.multiRes.path = pPath + pData.multiRes.path;
                pData.multiRes.fallbackPath = pPath + pData.multiRes.fallbackPath;
                // console.log("processing scene "+pNr+" of "+pFolders.length+": success");
                // dann ab ins Sammel-Objekt ...
                // this.scenes[pFolders[i]] = pData;
                pTemp[pFolders[i]] = pData;
              } else {
                // console.log("processing scene "+pNr+" of "+pFolders.length+": error in data structure, skipping item");
              }
            }
            pCounter ++;
            if (pCounter == pFolders.length) {
              // erzeuge korrekt sortiertes Objekt ...
              for (let x in pFolders) {
                if (pFolders[x] in pTemp) {
                  this.scenes[pFolders[x]] = pTemp[pFolders[x]];
                }
              }
              // setze App-Status auf "loaded" ...
              this.appStatus = "loaded";
            }
          // }, response => {
          }, response => {
            // error callback
            console.log("loading scene "+pNr+" of "+pFolders.length+": error", response);
            pCounter ++;
            if (pCounter == pFolders.length) {
              // erzeuge korrekt sortiertes Objekt ...
              for (let x in pFolders) {
                if (pFolders[x] in pTemp) {
                  this.scenes[pFolders[x]] = pTemp[pFolders[x]];
                }
              }
              // setze App-Status auf "loaded" ...
              this.appStatus = "loaded";
            }
          });
        }
        // this.scene = response.body;
      }, response => {
        // error callback
        console.log("loading baseFile: error", response);
        this.appStatus = "loaded";
        this.$router.push('/error');
      });
    },
  },
  computed: {

  }
}
</script>

<style lang="scss">
@import "./style/main.scss";
</style>
